<template>
    <div class="choose-main-symptom-popup-container">

        <v-dialog v-model="getMustShowChooseMainSymptomPopup"
                  scrollable
                  max-width="600px"
                  content-class="choose-main-symptom-popup"
                  transition="dialog-bottom-transition"
                  persistent
        >
            <div class="choose-main-symptom-popup-content-wrapper component-bg-color">
                <div class="choose-main-symptom-popup--header flex-align-justify-center">
                    <close-icon
                        id="btnCloseChooseMainSymptomPopup"
                        @click.native="closeMainSymptomPopup"
                        :svg-fill-class="'svg-secondary-color'"
                        class="font-weight-light icon-close-popup cursor-pointer"
                        >
                    </close-icon>
                    <span class="choose-main-symptom-popup--header-text">{{text("api.chatbot.title.searchSymptomDialog")}}</span>
                </div>
                <div class="choose-main-symptom-popup--conversation">
                    <message-received
                        :msgText="text('api.chatbot.headline.selectMainSymptom')"
                        :is-edit="getIsEditMode"
                    ></message-received>
                </div>
                <div class="choose-main-symptom-popup--tabs-headers">
                    <v-btn @click="switchToTab(TABS.SEARCH)"
                           id="tabHeadChooseMainSymptomSearch"
                           class="choose-main-symptom-popup--tabs-button search-section-btn text-transform-none font-weight-regular"

                           :style="{
                                'color': (crtActiveTab === TABS.SEARCH ? getCurrentGuiThemeColor+' !important' : ''),
                                'border-top': (crtActiveTab === TABS.SEARCH ? '2px solid '+ getCurrentGuiThemeColor+' !important' : ''),
                                'border-bottom': (crtActiveTab === TABS.SEARCH ? '2px solid '+ getCurrentGuiThemeColor+' !important' : ''),
                                'border-left': (crtActiveTab === TABS.SEARCH ? '2px solid '+ getCurrentGuiThemeColor+' !important' : ''),
                                'border-right': (crtActiveTab === TABS.SEARCH ? '2px solid '+ getCurrentGuiThemeColor+' !important' : ''),
                                'font-weight': '700'
                           }"
                           flat
                    >
                        {{text("api.chatbot.option.searchMainSymptom")}}
                    </v-btn>
                    <v-btn @click="switchToTab(TABS.CHAPTERS)"
                           id="tabHeadChooseMainSymptomChapters"
                           class="choose-main-symptom-popup--tabs-button chapters-section-btn text-transform-none font-weight-regular"

                           :style="{
                                'color': (crtActiveTab === TABS.CHAPTERS ? getCurrentGuiThemeColor+' !important' : ''),
                                'border-top': (crtActiveTab === TABS.CHAPTERS ? '2px solid '+  getCurrentGuiThemeColor+' !important' : ''),
                                'border-right': (crtActiveTab === TABS.CHAPTERS ? '2px solid '+  getCurrentGuiThemeColor+' !important' : ''),
                                'border-bottom': (crtActiveTab === TABS.CHAPTERS ? '2px solid '+  getCurrentGuiThemeColor+' !important' : ''),
                                'border-left': (crtActiveTab === TABS.CHAPTERS ? '2px solid '+  getCurrentGuiThemeColor+' !important' : ''),
                                'font-weight': '700'
                           }"
                           flat
                    >
                        {{text("api.chatbot.option.browseMainSymptom")}}
                    </v-btn>
                </div>
                <div v-if="getMustShowChooseMainSymptomPopup" class="choose-main-symptom-popup--tabs-content">

                    <search-main-symptom v-if="crtActiveTab === TABS.SEARCH"></search-main-symptom>
                    <chapter-tree v-else-if="crtActiveTab === TABS.CHAPTERS"></chapter-tree>

                </div>

            </div>

        </v-dialog>

    </div>
</template>

<!-- ################################################################## -->

<script>

import {mapGetters} from 'vuex';
import MessageReceived from "../../MessageReceived";
import SearchMainSymptom from "./SearchMainSymptom";
import ChapterTree from "./ChapterTree";
import CloseIcon from "../../../../../common/components/svg/shared/closeIcon";

const TAB_LIST = {
    SEARCH: "SEARCH_MAIN_SYMPTOM_TAB",
    CHAPTERS: "CHAPTER_TREE_TAB"
};

export default {
    name: 'ChooseMainSymptomPopup',
    components: {
        CloseIcon,
        ChapterTree,
        SearchMainSymptom,
        MessageReceived
    },
    data() {
        return {
            TABS: {
                SEARCH: TAB_LIST.SEARCH,
                CHAPTERS: TAB_LIST.CHAPTERS
            },
            crtActiveTab: TAB_LIST.SEARCH
        }
    },

    computed: {
        ...mapGetters({
            getMustShowChooseMainSymptomPopup: 'ChatBotStore/getMustShowChooseMainSymptomPopup',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getConfirmedMainSymptom: 'ChatBotStore/getConfirmedMainSymptom',
            getChapterTree: 'ChatBotStore/getChapterTree',
            getIsEditMode:  'ChatBotStore/getIsEditAction',
            getAssessmentStatuses: "ChatBotStore/getAssessmentStatuses",
            getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor'
        })

    },

    watch: {
        getMustShowChooseMainSymptomPopup: (newVal, oldVal) => {

            if (newVal === true && typeof this.$nextTick !== 'undefined') {

                this.$nextTick(() => {
                    this.crtActiveTab = ((this.getConfirmedMainSymptom !== null) ? TAB_LIST.CHAPTERS : TAB_LIST.SEARCH);
                    this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                });
            }

        }
    },

    created() {
        window.addEventListener('resize', this.handleWindowResize);
    },
    mounted() {
        // TODO Check if can be removed
        this.$nextTick(() => {
            this.crtActiveTab = ((this.getConfirmedMainSymptom !== null) ? TAB_LIST.CHAPTERS : TAB_LIST.SEARCH);
            this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
        });
    },
    destroyed() {
        // Remove resize handler.
        window.removeEventListener('resize', this.handleWindowResize);
    },


    methods: {

        handleWindowResize() {
            this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
        },
        handleWindowScroll() {
            this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
        },
        switchToTab(tabKey) {
            this.crtActiveTab = tabKey;
        },


        closeMainSymptomPopup() {

            const overlay = document.getElementById("chooseMainSymptomKeyboardOverlay");
            if (overlay) {
                overlay.remove();
            }

            let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
            rootElement.classList.remove('hide-scroll');
            this.$store.commit('ChatBotStore/setMustShowChooseMainSymptomPopup', false);

            if(this.getIsEditMode){
                this.$store.commit('ChatBotStore/clearChapterTree');
            }
        },

    }
}

</script>

<!-- ################################################################## -->

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/main-symptom-popup/ChooseMainSymptomPopup.vue